module.exports = __webpack_public_path__ + "img/appIcon-menu--Settings--active.3de7b38f.svg";